import Modal from "react-modal";
import RedSmile from "../../../../assets/icons/red-smile.png";
import { useMainContext } from "../../../../context";

const OrderSuccessModal = () => {
  const { isOrderFinishedSuccess, setIsOrderFinishedSuccess } =
    useMainContext();

  return (
    <Modal
      isOpen={isOrderFinishedSuccess}
      ariaHideApp={false}
      style={{ overlay: { zIndex: 1000 } }}
      className="max-w-lg w-full bg-secondary-500 p-8 border-2 border-gray-200 rounded-lg fixed top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 z-50 shadow-lg"
    >
      <img
        alt="Smile"
        className="object-contain w-12 h-12 mx-auto"
        src={RedSmile}
      />

      <div className="flex flex-col">
        <p className="text-center text-primary-600 text-lg font-bold">
          Uhuuul!
        </p>
        <p className="text-lg text-primary-600 text-center mt-2 mb-4">
          Seu pedido foi enviado ao restaurante com sucesso, buddy!
        </p>
        <button
          className="w-full bg-white rounded-lg border-2 p-4 text-gray-500 hover:bg-gray-200 transition-colors font-bold"
          onClick={() => setIsOrderFinishedSuccess(false)}
        >
          Entendi
        </button>
      </div>
    </Modal>
  );
};

export default OrderSuccessModal;
